import { render, staticRenderFns } from "./HeroSliderComponent.vue?vue&type=template&id=7342d948&"
import script from "./HeroSliderComponent.vue?vue&type=script&lang=ts&"
export * from "./HeroSliderComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports